/**
 * SafeArea.ts - Platform-specific safe area handling
 *
 * Detects platform and applies appropriate safe area CSS variables.
 * Supports iOS, Android, Toss mini-app, and web.
 */

type Platform = 'ios' | 'android' | 'toss' | 'web';

export function detectPlatform(): Platform {
  const ua = navigator.userAgent;
  if (
    window.location.hostname.includes('toss') ||
    ua.includes('TossApp')
  ) {
    return 'toss';
  }
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'web';
}

export function applySafeArea(): void {
  const platform = detectPlatform();
  document.body.dataset.platform = platform;

  if (platform === 'toss') {
    // Toss uses --safe-top CSS variable
    const safeTop = getComputedStyle(document.documentElement)
      .getPropertyValue('--safe-top')
      .trim();
    document.documentElement.style.setProperty(
      '--safe-area-top',
      safeTop || '44px',
    );
  }
  // ios/android: CSS env(safe-area-inset-*) is applied automatically
  // (requires viewport-fit=cover in index.html)
}

export function getSafeAreaInsets(): {
  top: number;
  bottom: number;
  left: number;
  right: number;
} {
  const style = getComputedStyle(document.documentElement);
  const parse = (v: string) => parseInt(v) || 0;
  return {
    top: parse(style.getPropertyValue('--safe-area-inset-top')),
    bottom: parse(style.getPropertyValue('--safe-area-inset-bottom')),
    left: parse(style.getPropertyValue('--safe-area-inset-left')),
    right: parse(style.getPropertyValue('--safe-area-inset-right')),
  };
}
